import React, { ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../layout/Box';
import { makeCheckedControl } from './makeCheckedControl';

const HiddenInput = styled.input.withConfig({ displayName: 'HiddenInput' })`
    left: -100%;
    width: 300%;
    cursor: inherit;
    position: absolute;
    opacity: 0;
    height: 100%;
    top: 0;
    margin: 0;
    padding: 0;
    z-index: 1;
    outline: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

const Container = styled(Box)
    .withConfig({ displayName: 'Container' })
    .attrs((props) => ({
        ...props,
        overflow: 'hidden',
        position: 'relative',
    }))`
    display: inline-flex;
    width: 42px;
    min-width: 42px;
    height: 24px;
    border-radius: 12px;
    background-color: var(--control-secondary-background);

    &::after {
        content: '';
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: relative;
        left: 2px;
        top: 2px;
        background-color: var(--background-primary);
        transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    &[data-checked='true'] {
        background-color: var(--control-primary-background);

        &:hover {
            background-color: var(--control-primary-background-hover);
        }

        &::after {
            transform: translateX(calc(100% - 2px));
        }
    }

    &[data-disabled='true'] {
        &::after {
            background-color: var(--control-disabled-background);
        }
    }
`;

export const Switch = makeCheckedControl(
    forwardRef((props, ref: ForwardedRef<HTMLDivElement>) => {
        const { error, ...other } = props;

        return (
            <Container ref={ref} data-checked={props.checked} data-disabled={props.disabled}>
                <HiddenInput {...other} type="checkbox" />
            </Container>
        );
    }),
);
